//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Warehouse } from '@mui/icons-material';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getAdminData(cancelToken?: CancelToken | undefined): Promise<GetAdminForApplicationsDataResponse> {
        let url_ = this.baseUrl + "/api/ApplicationAdmin/GetAdminData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminData(_response);
        });
    }

    protected processGetAdminData(response: AxiosResponse): Promise<GetAdminForApplicationsDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetAdminForApplicationsDataResponse.fromJS(resultData200);
            return Promise.resolve<GetAdminForApplicationsDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdminForApplicationsDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    newDemoApplication(body: CreateApplicationRequest | undefined, cancelToken?: CancelToken | undefined): Promise<CreateApplicationResponse> {
        let url_ = this.baseUrl + "/api/Applications/newDemoApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewDemoApplication(_response);
        });
    }

    protected processNewDemoApplication(response: AxiosResponse): Promise<CreateApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CreateApplicationResponse.fromJS(resultData200);
            return Promise.resolve<CreateApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateApplicationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    newApplicationToPayment(body: CreateApplicationWithPaymentRequest | undefined, cancelToken?: CancelToken | undefined): Promise<CreateApplicationWithPaymentResponse> {
        let url_ = this.baseUrl + "/api/Applications/newApplicationToPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewApplicationToPayment(_response);
        });
    }

    protected processNewApplicationToPayment(response: AxiosResponse): Promise<CreateApplicationWithPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CreateApplicationWithPaymentResponse.fromJS(resultData200);
            return Promise.resolve<CreateApplicationWithPaymentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateApplicationWithPaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    auth(body: AuthRequest | undefined, cancelToken?: CancelToken | undefined): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined, cancelToken?: CancelToken | undefined): Promise<RefreshTokenReponse> {
        let url_ = this.baseUrl + "/Auth/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RefreshTokenReponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenReponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenReponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjects(cancelToken?: CancelToken | undefined): Promise<GetProjectsForUserResponse> {
        let url_ = this.baseUrl + "/Auth/getProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<GetProjectsForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProjectsForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsForUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteManyProjects(body: DeleteProjectsRequest | undefined, cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Auth/deleteManyProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteManyProjects(_response);
        });
    }

    protected processDeleteManyProjects(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @return Success
     */
    reauth(cancelToken?: CancelToken | undefined): Promise<ReauthResponse> {
        let url_ = this.baseUrl + "/Auth/reauth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReauth(_response);
        });
    }

    protected processReauth(response: AxiosResponse): Promise<ReauthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ReauthResponse.fromJS(resultData200);
            return Promise.resolve<ReauthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReauthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: CreatePaymentRequest | undefined, cancelToken?: CancelToken | undefined): Promise<CreatePaymentResponse> {
        let url_ = this.baseUrl + "/api/Subscription/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: AxiosResponse): Promise<CreatePaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CreatePaymentResponse.fromJS(resultData200);
            return Promise.resolve<CreatePaymentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePaymentResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProducts(cancelToken?: CancelToken | undefined): Promise<GetProductsForPaymentsResponse> {
        let url_ = this.baseUrl + "/api/Subscription/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<GetProductsForPaymentsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetProductsForPaymentsResponse.fromJS(resultData200);
            return Promise.resolve<GetProductsForPaymentsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductsForPaymentsResponse>(null as any);
    }

    /**
     * @param gridType (optional) 
     * @return Success
     */
    getGridSettings(gridType: GridType | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserGridSettingsResponse> {
        let url_ = this.baseUrl + "/api/Users/getGridSettings?";
        if (gridType === null)
            throw new Error("The parameter 'gridType' cannot be null.");
        else if (gridType !== undefined)
            url_ += "GridType=" + encodeURIComponent("" + gridType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGridSettings(_response);
        });
    }

    protected processGetGridSettings(response: AxiosResponse): Promise<GetUserGridSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetUserGridSettingsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserGridSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserGridSettingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addGridSetting(body: AddUsersGridSettingsRequest | undefined, cancelToken?: CancelToken | undefined): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/api/Users/addGridSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddGridSetting(_response);
        });
    }

    protected processAddGridSetting(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGridSetting(body: UpdateUsersGridSettingsRequest | undefined, cancelToken?: CancelToken | undefined): Promise<UpdateUsersGridSettingsResponse> {
        let url_ = this.baseUrl + "/api/Users/updateGridSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGridSetting(_response);
        });
    }

    protected processUpdateGridSetting(response: AxiosResponse): Promise<UpdateUsersGridSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = UpdateUsersGridSettingsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateUsersGridSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUsersGridSettingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserIdentity(body: CreateUsersIdentityRequest | undefined, cancelToken?: CancelToken | undefined): Promise<CreateUserAuthResponse> {
        let url_ = this.baseUrl + "/api/Users/createUserIdentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserIdentity(_response);
        });
    }

    protected processCreateUserIdentity(response: AxiosResponse): Promise<CreateUserAuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CreateUserAuthResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserAuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserAuthResponse>(null as any);
    }
}

export class AddUsersGridSettingsRequest implements IAddUsersGridSettingsRequest {
    name?: string | undefined;
    gridData?: string | undefined;
    isGroupingEnabled?: boolean;
    isToolbarEnabled?: boolean;
    gridType?: GridType;

    constructor(data?: IAddUsersGridSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.gridData = _data["gridData"];
            this.isGroupingEnabled = _data["isGroupingEnabled"];
            this.isToolbarEnabled = _data["isToolbarEnabled"];
            this.gridType = _data["gridType"];
        }
    }

    static fromJS(data: any): AddUsersGridSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersGridSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["gridData"] = this.gridData;
        data["isGroupingEnabled"] = this.isGroupingEnabled;
        data["isToolbarEnabled"] = this.isToolbarEnabled;
        data["gridType"] = this.gridType;
        return data;
    }
}

export interface IAddUsersGridSettingsRequest {
    name?: string | undefined;
    gridData?: string | undefined;
    isGroupingEnabled?: boolean;
    isToolbarEnabled?: boolean;
    gridType?: GridType;
}

export class AuthRequest implements IAuthRequest {
    username?: string | undefined;
    password?: string | undefined;
    applicationId?: number | undefined;

    constructor(data?: IAuthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): AuthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IAuthRequest {
    username?: string | undefined;
    password?: string | undefined;
    applicationId?: number | undefined;
}

export class AuthResponse implements IAuthResponse {
    token?: string | undefined;
    expireAt?: Date;
    refreshToken?: string | undefined;
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;
    isAdmin?: boolean;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.username = _data["username"];
            this.initials = _data["initials"];
            this.companyName = _data["companyName"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["username"] = this.username;
        data["initials"] = this.initials;
        data["companyName"] = this.companyName;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IAuthResponse {
    token?: string | undefined;
    expireAt?: Date;
    refreshToken?: string | undefined;
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;
    isAdmin?: boolean;
}

export class CreateApplicationRequest implements ICreateApplicationRequest {
    name!: string;
    source!: string;
    language!: string;
    email!: string;
    firstname!: string;
    lastname?: string | undefined;

    constructor(data?: ICreateApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.source = _data["source"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
        }
    }

    static fromJS(data: any): CreateApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["source"] = this.source;
        data["language"] = this.language;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        return data;
    }
}

export interface ICreateApplicationRequest {
    name: string;
    source: string;
    language: string;
    email: string;
    firstname: string;
    lastname?: string | undefined;
}

export class CreateApplicationResponse implements ICreateApplicationResponse {
    userId?: number;
    userName?: string | undefined;
    appName?: string | undefined;
    appId?: number;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    initials?: string | undefined;
    expireAt?: Date;
    isAdmin?: boolean;

    constructor(data?: ICreateApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.appName = _data["appName"];
            this.appId = _data["appId"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.initials = _data["initials"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): CreateApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["appName"] = this.appName;
        data["appId"] = this.appId;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["initials"] = this.initials;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface ICreateApplicationResponse {
    userId?: number;
    userName?: string | undefined;
    appName?: string | undefined;
    appId?: number;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    initials?: string | undefined;
    expireAt?: Date;
    isAdmin?: boolean;
}

export class CreateApplicationWithPaymentRequest implements ICreateApplicationWithPaymentRequest {
    name!: string;
    source!: string;
    language!: string;
    email!: string;
    firstname!: string;
    lastname?: string | undefined;
    companyIC!: string;
    companyDIC!: string;
    companyState!: string;
    companyZIP!: string;
    companyStreet!: string;
    companyCity!: string;

    constructor(data?: ICreateApplicationWithPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.source = _data["source"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.companyIC = _data["companyIC"];
            this.companyDIC = _data["companyDIC"];
            this.companyState = _data["companyState"];
            this.companyZIP = _data["companyZIP"];
            this.companyStreet = _data["companyStreet"];
            this.companyCity = _data["companyCity"];
        }
    }

    static fromJS(data: any): CreateApplicationWithPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationWithPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["source"] = this.source;
        data["language"] = this.language;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["companyIC"] = this.companyIC;
        data["companyDIC"] = this.companyDIC;
        data["companyState"] = this.companyState;
        data["companyZIP"] = this.companyZIP;
        data["companyStreet"] = this.companyStreet;
        data["companyCity"] = this.companyCity;
        return data;
    }
}

export interface ICreateApplicationWithPaymentRequest {
    name: string;
    source: string;
    language: string;
    email: string;
    firstname: string;
    lastname?: string | undefined;
    companyIC: string;
    companyDIC: string;
    companyState: string;
    companyZIP: string;
    companyStreet: string;
    companyCity: string;
}

export class CreateApplicationWithPaymentResponse implements ICreateApplicationWithPaymentResponse {
    userId?: number;
    userName?: string | undefined;
    appName?: string | undefined;
    appId?: number;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    initials?: string | undefined;
    expireAt?: Date;
    isAdmin?: boolean;

    constructor(data?: ICreateApplicationWithPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.appName = _data["appName"];
            this.appId = _data["appId"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.initials = _data["initials"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): CreateApplicationWithPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationWithPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["appName"] = this.appName;
        data["appId"] = this.appId;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["initials"] = this.initials;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface ICreateApplicationWithPaymentResponse {
    userId?: number;
    userName?: string | undefined;
    appName?: string | undefined;
    appId?: number;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    initials?: string | undefined;
    expireAt?: Date;
    isAdmin?: boolean;
}

export class CreatePaymentRequest implements ICreatePaymentRequest {
    paymentRecuringType?: PaymentRecuringType;
    subscriptionPlan?: SubscriptionPlans;
    currency?: string | undefined;
    productId?: string | undefined;
    priceId?: string | undefined;

    constructor(data?: ICreatePaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentRecuringType = _data["paymentRecuringType"];
            this.subscriptionPlan = _data["subscriptionPlan"];
            this.currency = _data["currency"];
            this.productId = _data["productId"];
            this.priceId = _data["priceId"];
        }
    }

    static fromJS(data: any): CreatePaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentRecuringType"] = this.paymentRecuringType;
        data["subscriptionPlan"] = this.subscriptionPlan;
        data["currency"] = this.currency;
        data["productId"] = this.productId;
        data["priceId"] = this.priceId;
        return data;
    }
}

export interface ICreatePaymentRequest {
    paymentRecuringType?: PaymentRecuringType;
    subscriptionPlan?: SubscriptionPlans;
    currency?: string | undefined;
    productId?: string | undefined;
    priceId?: string | undefined;
}

export class CreatePaymentResponse implements ICreatePaymentResponse {
    paymentUrl?: string | undefined;

    constructor(data?: ICreatePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentUrl = _data["paymentUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentUrl"] = this.paymentUrl;
        return data;
    }
}

export interface ICreatePaymentResponse {
    paymentUrl?: string | undefined;
}

export class CreateUserAuthResponse implements ICreateUserAuthResponse {
    token?: string | undefined;
    expireAt?: Date;
    refreshToken?: string | undefined;
    userId?: number;
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;
    isAdmin?: boolean;

    constructor(data?: ICreateUserAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.initials = _data["initials"];
            this.companyName = _data["companyName"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): CreateUserAuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserAuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["initials"] = this.initials;
        data["companyName"] = this.companyName;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface ICreateUserAuthResponse {
    token?: string | undefined;
    expireAt?: Date;
    refreshToken?: string | undefined;
    userId?: number;
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;
    isAdmin?: boolean;
}

export class CreateUsersIdentityRequest implements ICreateUsersIdentityRequest {
    userFirstname?: string | undefined;
    userEmail?: string | undefined;
    userLastname?: string | undefined;
    applicationId?: number;

    constructor(data?: ICreateUsersIdentityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userFirstname = _data["userFirstname"];
            this.userEmail = _data["userEmail"];
            this.userLastname = _data["userLastname"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): CreateUsersIdentityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUsersIdentityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userFirstname"] = this.userFirstname;
        data["userEmail"] = this.userEmail;
        data["userLastname"] = this.userLastname;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface ICreateUsersIdentityRequest {
    userFirstname?: string | undefined;
    userEmail?: string | undefined;
    userLastname?: string | undefined;
    applicationId?: number;
}

export class DeleteProjectDTO implements IDeleteProjectDTO {
    id?: number;
    timestamp?: Date;

    constructor(data?: IDeleteProjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteProjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeleteProjectDTO {
    id?: number;
    timestamp?: Date;
}

export class DeleteProjectsRequest implements IDeleteProjectsRequest {
    selectedProjects?: DeleteProjectDTO[] | undefined;

    constructor(data?: IDeleteProjectsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedProjects"])) {
                this.selectedProjects = [] as any;
                for (let item of _data["selectedProjects"])
                    this.selectedProjects!.push(DeleteProjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteProjectsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedProjects)) {
            data["selectedProjects"] = [];
            for (let item of this.selectedProjects)
                data["selectedProjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeleteProjectsRequest {
    selectedProjects?: DeleteProjectDTO[] | undefined;
}

export class EmptyResponse implements IEmptyResponse {
    unit?: Unit;

    constructor(data?: IEmptyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmptyResponse {
    unit?: Unit;
}

export class GetAdminForApplicationsDataResponse implements IGetAdminForApplicationsDataResponse {
    appId?: number;
    appName?: string | undefined;
    users?: UserForAdminDTO[] | undefined;

    constructor(data?: IGetAdminForApplicationsDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appName = _data["appName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserForAdminDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAdminForApplicationsDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdminForApplicationsDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appName"] = this.appName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAdminForApplicationsDataResponse {
    appId?: number;
    appName?: string | undefined;
    users?: UserForAdminDTO[] | undefined;
}

export class GetProductsForPaymentsResponse implements IGetProductsForPaymentsResponse {
    products?: ProductDTO[] | undefined;

    constructor(data?: IGetProductsForPaymentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductsForPaymentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsForPaymentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProductsForPaymentsResponse {
    products?: ProductDTO[] | undefined;
}

export class GetProjectsForUserResponse implements IGetProjectsForUserResponse {
    projects?: ProjectDTO[] | undefined;

    constructor(data?: IGetProjectsForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectsForUserResponse {
    projects?: ProjectDTO[] | undefined;
}

export class GetUserGridSettingsResponse implements IGetUserGridSettingsResponse {
    gridSettings?: GridSettingsDTO[] | undefined;

    constructor(data?: IGetUserGridSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gridSettings"])) {
                this.gridSettings = [] as any;
                for (let item of _data["gridSettings"])
                    this.gridSettings!.push(GridSettingsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserGridSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserGridSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gridSettings)) {
            data["gridSettings"] = [];
            for (let item of this.gridSettings)
                data["gridSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserGridSettingsResponse {
    gridSettings?: GridSettingsDTO[] | undefined;
}

export class GridSettingsDTO implements IGridSettingsDTO {
    id?: number;
    name?: string | undefined;
    gridData?: string | undefined;
    isGroupingEnabled?: boolean;
    isToolbarEnabled?: boolean;
    isFavouriteInGroup?: boolean;
    rowVersion?: Date;

    constructor(data?: IGridSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.gridData = _data["gridData"];
            this.isGroupingEnabled = _data["isGroupingEnabled"];
            this.isToolbarEnabled = _data["isToolbarEnabled"];
            this.isFavouriteInGroup = _data["isFavouriteInGroup"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GridSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["gridData"] = this.gridData;
        data["isGroupingEnabled"] = this.isGroupingEnabled;
        data["isToolbarEnabled"] = this.isToolbarEnabled;
        data["isFavouriteInGroup"] = this.isFavouriteInGroup;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGridSettingsDTO {
    id?: number;
    name?: string | undefined;
    gridData?: string | undefined;
    isGroupingEnabled?: boolean;
    isToolbarEnabled?: boolean;
    isFavouriteInGroup?: boolean;
    rowVersion?: Date;
}

export enum GridType {
    Projects = 0,
    Todos = 1,
    Users = 2,
    Invoices = 3,
    Diaries = 4,
    DiaryRecords = 5,
    Warehouses = 6,
    Manufacturers = 7,
    productCategories = 8,
    Products = 9,
    Employees = 10,
    WarehouseProducts = 11,
    WarehousesReport = 12,
    ProductMovements = 13
}

export enum PaymentRecuringType {
    None = 0,
    Monthly = 1,
    Yearly = 2,
    SingleMonthly = 3,
    SingleYearly = 4,
}

export class PriceDTO implements IPriceDTO {
    priceId?: string | undefined;
    priceName?: string | undefined;
    currency?: string | undefined;
    value?: number;
    recuring?: PaymentRecuringType;

    constructor(data?: IPriceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceId = _data["priceId"];
            this.priceName = _data["priceName"];
            this.currency = _data["currency"];
            this.value = _data["value"];
            this.recuring = _data["recuring"];
        }
    }

    static fromJS(data: any): PriceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceId"] = this.priceId;
        data["priceName"] = this.priceName;
        data["currency"] = this.currency;
        data["value"] = this.value;
        data["recuring"] = this.recuring;
        return data;
    }
}

export interface IPriceDTO {
    priceId?: string | undefined;
    priceName?: string | undefined;
    currency?: string | undefined;
    value?: number;
    recuring?: PaymentRecuringType;
}

export class ProductDTO implements IProductDTO {
    productId?: string | undefined;
    name?: string | undefined;
    prices?: PriceDTO[] | undefined;
    plan?: SubscriptionPlans;

    constructor(data?: IProductDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PriceDTO.fromJS(item));
            }
            this.plan = _data["plan"];
        }
    }

    static fromJS(data: any): ProductDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        data["plan"] = this.plan;
        return data;
    }
}

export interface IProductDTO {
    productId?: string | undefined;
    name?: string | undefined;
    prices?: PriceDTO[] | undefined;
    plan?: SubscriptionPlans;
}

export class ProjectDTO implements IProjectDTO {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    code?: string | undefined;
    rowVersion?: Date;

    constructor(data?: IProjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.showToEmployees = _data["showToEmployees"];
            this.code = _data["code"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["showToEmployees"] = this.showToEmployees;
        data["code"] = this.code;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProjectDTO {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    showToEmployees?: boolean;
    code?: string | undefined;
    rowVersion?: Date;
}

export class ReauthResponse implements IReauthResponse {
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: IReauthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.initials = _data["initials"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): ReauthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReauthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["initials"] = this.initials;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IReauthResponse {
    username?: string | undefined;
    initials?: string | undefined;
    companyName?: string | undefined;
}

export class RefreshTokenReponse implements IRefreshTokenReponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTokenReponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshTokenReponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export enum SubscriptionPlans {
    Start = 0,
    Business = 1,
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export class UpdateUsersGridSettingsRequest implements IUpdateUsersGridSettingsRequest {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateUsersGridSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateUsersGridSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUsersGridSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateUsersGridSettingsRequest {
    id?: number;
    name?: string | undefined;
}

export class UpdateUsersGridSettingsResponse implements IUpdateUsersGridSettingsResponse {
    concurrencyData?: GridSettingsDTO;

    constructor(data?: IUpdateUsersGridSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.concurrencyData = _data["concurrencyData"] ? GridSettingsDTO.fromJS(_data["concurrencyData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUsersGridSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUsersGridSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["concurrencyData"] = this.concurrencyData ? this.concurrencyData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateUsersGridSettingsResponse {
    concurrencyData?: GridSettingsDTO;
}

export class UserForAdminDTO implements IUserForAdminDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    identityEmail?: string | undefined;

    constructor(data?: IUserForAdminDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.identityEmail = _data["identityEmail"];
        }
    }

    static fromJS(data: any): UserForAdminDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserForAdminDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["identityEmail"] = this.identityEmail;
        return data;
    }
}

export interface IUserForAdminDTO {
    id?: number;
    firstname?: string | undefined;
    lastname?: string | undefined;
    identityEmail?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}